<!-- page header -->
<div class="inner-page-header">
  <h3>إنشاء طلب جديد</h3>
</div>
<!-- end page header -->
<div class="inner-content">
  <app-stepper  [selectedView]="stepper"></app-stepper>
  <div >
    @switch (selectedView) {
      @default {
        <app-build-details (building_view)="getView($event)"></app-build-details>
      }
      @case ('address') {
        <app-address-details [orderId]="orderId" [dynamicService]="dynamicService" (address_view)="getView($event)"></app-address-details>
      }
@case ('summary') {
        <app-order-summary [orderId]="orderId" (summary_view)="getView($event)"></app-order-summary>
      }
    }
  </div>
</div>
